import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const AddTab = ({ addTab, label }) => {
    return (
        <div>
            <button className="button -primary -small" onClick={addTab}>
                <FontAwesomeIcon icon={faPlus} /> {label}
            </button>
        </div>
    );
};

export default AddTab;
